import { DRAWER_TABS } from '../../../../constants';
import { User } from '../../../../shared/types';
import { EditAdminForm, EditCareProviderForm, EditPatientForm } from '.';

type EditFormWrapperProps = {
  userToEdit: User;
  selectedDrawerTab: string | undefined;
  closeDialog: () => void;
  editUser: (user: User) => void;
  openRemoveUserDialog?: () => void;
};

export const EditForm: React.FC<EditFormWrapperProps> = ({
  selectedDrawerTab,
  ...rest
}) => {
  return (
    <>
      {selectedDrawerTab === DRAWER_TABS.PATIENTS && (
        <EditPatientForm {...rest} />
      )}
      {selectedDrawerTab === DRAWER_TABS.CARE_PROVIDERS && (
        <EditCareProviderForm {...rest} />
      )}
      {selectedDrawerTab === DRAWER_TABS.ADMINS && <EditAdminForm {...rest} />}
    </>
  );
};
